import { render, staticRenderFns } from "./OriginCountry.vue?vue&type=template&id=b795a402&"
import script from "./OriginCountry.vue?vue&type=script&lang=js&"
export * from "./OriginCountry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports